import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';

import AddToTeamImg from 'img/workspace-onboarding/add-to-team-library.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import {
  launchAddVideoToTeamArticleLink,
  launchAddVideoToTeamIntercomTutorial,
} from '../../../../onboarding-actions';
import { ADD_VIDEO_TO_TEAM_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const AddVideoToTeamCard = ({ cardConfig }) => {
  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={launchAddVideoToTeamArticleLink}
    >
      Learn more
    </DashboardOnboardingSecondaryAction>
  );

  const primaryAction = (
    <Button onClick={launchAddVideoToTeamIntercomTutorial}>Show me how</Button>
  );

  const centerpiece = <img src={AddToTeamImg} />;

  return (
    <DashboardOnboardingCard
      cardKey={ADD_VIDEO_TO_TEAM_CARD_KEY}
      cardConfig={cardConfig}
      heading="Add videos to the Team Library"
      description="Organize, edit and manage videos as a team."
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="You added a video to the Team Library."
    />
  );
};

export default AddVideoToTeamCard;
